import { render, staticRenderFns } from "./index.vue?vue&type=template&id=548785fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./productResume.scss?vue&type=style&index=0&id=548785fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548785fe",
  null
  
)

export default component.exports